import { useIntl } from 'react-intl'

import { NavigationLink } from './NavigationLink'

export const ExpertDesktopNavigation = () => {
  const { formatMessage } = useIntl()

  return (
    <nav>
      <ul className="flex items-baseline gap-6">
        <li>
          <NavigationLink to="/expert/meetings">
            {formatMessage({ id: 'HOME' })}
          </NavigationLink>
        </li>
        <li>
          <NavigationLink to="/expert/personal-data">
            {formatMessage({ id: 'PROFILE' })}
          </NavigationLink>
        </li>
        <li>
          <NavigationLink to="/expert/bank-data">
            {formatMessage({ id: 'BANK_DATA' })}
          </NavigationLink>
        </li>
        <li>
          <NavigationLink to="/expert/skills">
            {formatMessage({ id: 'SKILLS' })}
          </NavigationLink>
        </li>
      </ul>
    </nav>
  )
}
